<head>
  <!-- Custom styles for this template -->
  <link href="./default.component.css" rel="stylesheet">
</head>

<body>

  <app-navbar role="topbar"></app-navbar>

  <div class="container-fluid" id="app-container">
    <div class="row">
      <app-sidebar role="sidebar"></app-sidebar>

      <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
        <div class="col-md-12" style="padding:20px">
          <alert></alert>
          <router-outlet></router-outlet>
        </div>
      </main>

    </div>
  </div>


  <script src="https://code.jquery.com/jquery-3.4.1.slim.min.js" integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n" crossorigin="anonymous"></script>
  <script>window.jQuery || document.write('<script src="/docs/4.4/assets/js/vendor/jquery.slim.min.js"><\/script>')</script>
  <script src="/docs/4.4/dist/js/bootstrap.bundle.min.js" integrity="sha384-6khuMg9gaYr5AxOqhkVIODVIvm9ynTT5J4V1cfthmT+emCG6yVmEZsRHdxlotUnm" crossorigin="anonymous"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/feather-icons/4.9.0/feather.min.js"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.3/Chart.min.js"></script>
  <script src="dashboard.js"></script>
</body>
